import { ClientJwtManager } from '../jwt/ClientJwtManager';

/**
 * Resolves once the browser has a usable JWT.
 *
 * A missing JWT tries refresh first and falls back to anonymous login only on 400/401; concurrent callers
 * (SessionKeepAlive, SessionClient, forms) share one in-flight request inside ClientJwtManager.
 * Forms await this before calling a server action, so a fast submit waits instead of failing.
 */
export async function ensureSession(): Promise<string> {
  return ClientJwtManager.getValidJwtToken();
}
